import MainLayout from '@/common/components/layouts/MainLayout';
import { PropsWithChildren } from 'react';

const BodyInsuranceInsurance = ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title={'بیمه بدنه'} header="titleHeader">
      {children}
    </MainLayout>
  );
};

export default BodyInsuranceInsurance;
